/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddShipmentTrackingRecordRequest,
    AddShippingTrackingInfoRequest,
    BatchAddShipmentTrackingRecordRequest,
    BatchAddShipmentTrackingRecordResponse,
    BatchGetShippingCostRequest,
    BatchGetShippingLabelResponse,
    BatchPreviewShippingCostResponse,
    BatchRefundOrderRequest,
    BatchUpdatePackageTemplateRequest,
    BatchUpdatePackageTemplateResponse,
    CancelOrderRequest,
    CheckFreeShippingResponse,
    ChooseServiceLevelRequest,
    CreateOrderDto,
    CreateOrderDtoV2,
    CreateOrderDtoV3,
    CreateOrderResponse,
    CreateOrderV3Response,
    CreateShipmentRequest,
    GenerateLabelRequest,
    GetIcsResponse,
    GetOrderDigitalProductResponse,
    GetShippingCostRequest,
    LabelRegenerationJobStatus,
    OrderRefundPreviewResponse,
    OrderRefundsDetailResponse,
    OrdersDetailWithRefundResponse,
    PatchShipmentTrackingRecordItemRequest,
    PickupNotifyDto,
    PreviewBatchRefundOrderRequest,
    PreviewOrderDto,
    PreviewOrderResponse,
    PreviewRefundOrderRequest,
    PreviewShippingCostResponse,
    QueryShipmentRequest,
    RefundOrderRequest,
    RetryPaymentRequest,
    RetryPaymentResponse,
    SelectShipmentRateRequest,
    ShipmentTrackingRecordBackwardCompatibleResponse,
    ShipmentTrackingRecordResponse,
    ShipmentTransactionResponse,
    ShippingCostItem,
    ShippingFeeResponse,
    UpdateOrderByCommissionFeeRateRequest,
    UpdateOrderPackedStatusDto,
    UpdateOrderPickupStatusDto,
    UpdateOrderTrackingInfoDto,
    UpdatePackageTemplateRequest,
    UpdateShipmentConfigRequest,
    UpdateShipmentExtraRequest,
    UpdateShipmentExtraResponse,
    UpdateShippingAddressBySellerRequest,
    UpdateShippingAddressRequest,
    VoidShippingLabelRequest,
} from '../models';

export interface OrderApiControllerAcceptGiftingRequest {
    orderId: string;
}

export interface OrderApiControllerAddShippingTrackingInfoRequest {
    orderId: string;
    addShippingTrackingInfoRequest: AddShippingTrackingInfoRequest;
}

export interface OrderApiControllerAddTrackingRecordRequest {
    orderId: string;
    addShipmentTrackingRecordRequest: AddShipmentTrackingRecordRequest;
}

export interface OrderApiControllerBatchAddTrackingRecordRequest {
    batchAddShipmentTrackingRecordRequest: BatchAddShipmentTrackingRecordRequest;
}

export interface OrderApiControllerBatchGetShippingLabelRequest {
    batchGetShippingCostRequest: BatchGetShippingCostRequest;
}

export interface OrderApiControllerBatchPreviewShippingCostRequest {
    packageTemplateId: string;
    orderIds: Array<string>;
}

export interface OrderApiControllerBatchRefundRequest {
    batchRefundOrderRequest: BatchRefundOrderRequest;
}

export interface OrderApiControllerBatchUpdatePackageTemplateRequest {
    batchUpdatePackageTemplateRequest: BatchUpdatePackageTemplateRequest;
}

export interface OrderApiControllerCancelOrderRequest {
    orderId: string;
    cancelOrderRequest: CancelOrderRequest;
}

export interface OrderApiControllerCaptureRequest {
    masterOrderId: string;
}

export interface OrderApiControllerCheckFreeShippingRequest {
    userId: string;
    sellerId: string;
}

export interface OrderApiControllerChooseServiceLevelRequest {
    orderId: string;
    chooseServiceLevelRequest: ChooseServiceLevelRequest;
}

export interface OrderApiControllerCreateOrderRequest {
    createOrderDto: CreateOrderDto;
}

export interface OrderApiControllerCreateOrderInMultiCurrencyRequest {
    createOrderDtoV3: CreateOrderDtoV3;
}

export interface OrderApiControllerCreateOrderV2Request {
    createOrderDtoV2: CreateOrderDtoV2;
}

export interface OrderApiControllerCreateShipmentRequest {
    orderId: string;
    createShipmentRequest?: CreateShipmentRequest;
}

export interface OrderApiControllerDownloadIcsRequest {
    orderId: string;
}

export interface OrderApiControllerDownloadOrderDigitalAssetRequest {
    assetId: string;
    signature: string;
    version: string;
}

export interface OrderApiControllerExportLiveStreamOrdersAsCSVRequest {
    liveStreamId: string;
    target?: OrderApiControllerExportLiveStreamOrdersAsCSVTargetEnum;
    shippingMethod?: Array<OrderApiControllerExportLiveStreamOrdersAsCSVShippingMethodEnum>;
}

export interface OrderApiControllerExportSellerUnshippedOrdersAsCSVRequest {
    sellerId: string;
    createdBefore?: string;
}

export interface OrderApiControllerFinalizeOrderRequest {
    orderId: string;
}

export interface OrderApiControllerGenerateLabelRequest {
    orderId: string;
    generateLabelRequest: GenerateLabelRequest;
}

export interface OrderApiControllerGetOrderDigitalAssetRequest {
    orderId: string;
}

export interface OrderApiControllerGetOrderStatsRequest {
    orderId: string;
}

export interface OrderApiControllerGetShipmentTransactionsRequest {
    orderId: string;
}

export interface OrderApiControllerGetShippingFeeRequest {
    sellerId: string;
    liveStreamId?: string;
}

export interface OrderApiControllerGetShippingLabelRequest {
    orderId: string;
    getShippingCostRequest: GetShippingCostRequest;
}

export interface OrderApiControllerGetTrackingRecordsRequest {
    orderId: string;
}

export interface OrderApiControllerGetTrackingRecordsBackwardCompatibleRequest {
    orderId: string;
}

export interface OrderApiControllerNotifyRequest {
    masterOrderId: string;
    pickupNotifyDto?: PickupNotifyDto;
}

export interface OrderApiControllerOrderRefundsDetailRequest {
    orderIds: Array<string>;
    type?: OrderApiControllerOrderRefundsDetailTypeEnum;
    sortOrder?: OrderApiControllerOrderRefundsDetailSortOrderEnum;
}

export interface OrderApiControllerOrdersDetailWithRefundRequest {
    orderId: string;
    includeOrdersInSameOrderGroup?: boolean;
}

export interface OrderApiControllerPreviewBatchRefundRequest {
    previewBatchRefundOrderRequest: PreviewBatchRefundOrderRequest;
}

export interface OrderApiControllerPreviewOrderRequest {
    previewOrderDto: PreviewOrderDto;
    userAgent?: string;
    xPopPlatform?: OrderApiControllerPreviewOrderXPopPlatformEnum;
}

export interface OrderApiControllerPreviewRefundRequest {
    orderId: string;
    previewRefundOrderRequest: PreviewRefundOrderRequest;
}

export interface OrderApiControllerPreviewShippingCostRequest {
    orderId: string;
    packageTemplateId: string;
}

export interface OrderApiControllerQueryShipmentRequest {
    orderId: string;
    queryShipmentRequest: QueryShipmentRequest;
}

export interface OrderApiControllerReCreatShipmentRequest {
    orderId: string;
}

export interface OrderApiControllerRefundRequest {
    orderId: string;
    refundOrderRequest: RefundOrderRequest;
}

export interface OrderApiControllerRetryOrderPaymentRequest {
    orderId: string;
    retryPaymentRequest: RetryPaymentRequest;
}

export interface OrderApiControllerSelectShipmentRateRequest {
    orderId: string;
    selectShipmentRateRequest: SelectShipmentRateRequest;
}

export interface OrderApiControllerSendOrderConfirmationEmailRequest {
    orderId: string;
}

export interface OrderApiControllerSendOrderShippedEmailRequest {
    masterOrderId: string;
}

export interface OrderApiControllerUpdateBraintreeTransactionsRequest {
    orderId: string;
}

export interface OrderApiControllerUpdateOrderByCommissionFeeRateRequest {
    liveStreamId: string;
    updateOrderByCommissionFeeRateRequest: UpdateOrderByCommissionFeeRateRequest;
}

export interface OrderApiControllerUpdateOrderPackedStatusRequest {
    masterOrderId: string;
    updateOrderPackedStatusDto: UpdateOrderPackedStatusDto;
}

export interface OrderApiControllerUpdateOrderPickupStatusRequest {
    masterOrderId: string;
    updateOrderPickupStatusDto: UpdateOrderPickupStatusDto;
}

export interface OrderApiControllerUpdatePackageTemplateRequest {
    orderId: string;
    updatePackageTemplateRequest: UpdatePackageTemplateRequest;
}

export interface OrderApiControllerUpdateShipmentConfigRequest {
    orderId: string;
    updateShipmentConfigRequest: UpdateShipmentConfigRequest;
}

export interface OrderApiControllerUpdateShipmentExtraRequest {
    orderId: string;
    updateShipmentExtraRequest: UpdateShipmentExtraRequest;
}

export interface OrderApiControllerUpdateShippingAddressRequest {
    orderId: string;
    updateShippingAddressRequest: UpdateShippingAddressRequest;
}

export interface OrderApiControllerUpdateShippingAddressBySellerRequest {
    orderId: string;
    updateShippingAddressBySellerRequest: UpdateShippingAddressBySellerRequest;
}

export interface OrderApiControllerUpdateTrackingInfoRequest {
    orderId: string;
    updateOrderTrackingInfoDto: UpdateOrderTrackingInfoDto;
}

export interface OrderApiControllerUpdateTrackingRecordRequest {
    orderId: string;
    recordId: string;
    patchShipmentTrackingRecordItemRequest: PatchShipmentTrackingRecordItemRequest;
}

export interface OrderApiControllerVoidShipmentRequest {
    orderId: string;
}

export interface OrderApiControllerVoidShippingLabelRequest {
    orderId: string;
    voidShippingLabelRequest: VoidShippingLabelRequest;
}

/**
 * 
 */
export class OrderApi extends runtime.BaseAPI {

    /**
     */
    async orderApiControllerAcceptGiftingRaw(requestParameters: OrderApiControllerAcceptGiftingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerAcceptGifting.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:accept-gifting`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerAcceptGifting(requestParameters: OrderApiControllerAcceptGiftingRequest): Promise<void> {
        await this.orderApiControllerAcceptGiftingRaw(requestParameters);
    }

    /**
     * for new shipping solution, add shipping tracking info for a main order, no matter the seller has chosen ship-with-popshop or arrange-with-my-shipping, but before the order is completed
     */
    async orderApiControllerAddShippingTrackingInfoRaw(requestParameters: OrderApiControllerAddShippingTrackingInfoRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerAddShippingTrackingInfo.');
        }

        if (requestParameters.addShippingTrackingInfoRequest === null || requestParameters.addShippingTrackingInfoRequest === undefined) {
            throw new runtime.RequiredError('addShippingTrackingInfoRequest','Required parameter requestParameters.addShippingTrackingInfoRequest was null or undefined when calling orderApiControllerAddShippingTrackingInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:addShippingTrackingInfo`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addShippingTrackingInfoRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * for new shipping solution, add shipping tracking info for a main order, no matter the seller has chosen ship-with-popshop or arrange-with-my-shipping, but before the order is completed
     */
    async orderApiControllerAddShippingTrackingInfo(requestParameters: OrderApiControllerAddShippingTrackingInfoRequest): Promise<void> {
        await this.orderApiControllerAddShippingTrackingInfoRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerAddTrackingRecordRaw(requestParameters: OrderApiControllerAddTrackingRecordRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerAddTrackingRecord.');
        }

        if (requestParameters.addShipmentTrackingRecordRequest === null || requestParameters.addShipmentTrackingRecordRequest === undefined) {
            throw new runtime.RequiredError('addShipmentTrackingRecordRequest','Required parameter requestParameters.addShipmentTrackingRecordRequest was null or undefined when calling orderApiControllerAddTrackingRecord.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:addTrackingRecord`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addShipmentTrackingRecordRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerAddTrackingRecord(requestParameters: OrderApiControllerAddTrackingRecordRequest): Promise<void> {
        await this.orderApiControllerAddTrackingRecordRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerBatchAddTrackingRecordRaw(requestParameters: OrderApiControllerBatchAddTrackingRecordRequest): Promise<runtime.ApiResponse<BatchAddShipmentTrackingRecordResponse>> {
        if (requestParameters.batchAddShipmentTrackingRecordRequest === null || requestParameters.batchAddShipmentTrackingRecordRequest === undefined) {
            throw new runtime.RequiredError('batchAddShipmentTrackingRecordRequest','Required parameter requestParameters.batchAddShipmentTrackingRecordRequest was null or undefined when calling orderApiControllerBatchAddTrackingRecord.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:batchAddTrackingRecord`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchAddShipmentTrackingRecordRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerBatchAddTrackingRecord(requestParameters: OrderApiControllerBatchAddTrackingRecordRequest): Promise<BatchAddShipmentTrackingRecordResponse> {
        const response = await this.orderApiControllerBatchAddTrackingRecordRaw(requestParameters);
        return await response.value();
    }

    /**
     * for new shipping solution, batch get shipping label for many shipping main orders, if the seller has chosen ship-with-popshop and no matter the main orders have shipping label or not, but before the orders are shipped and completed(note: upper limit of orderIds is 10)
     */
    async orderApiControllerBatchGetShippingLabelRaw(requestParameters: OrderApiControllerBatchGetShippingLabelRequest): Promise<runtime.ApiResponse<BatchGetShippingLabelResponse>> {
        if (requestParameters.batchGetShippingCostRequest === null || requestParameters.batchGetShippingCostRequest === undefined) {
            throw new runtime.RequiredError('batchGetShippingCostRequest','Required parameter requestParameters.batchGetShippingCostRequest was null or undefined when calling orderApiControllerBatchGetShippingLabel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:batchGetShippingLabel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchGetShippingCostRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for new shipping solution, batch get shipping label for many shipping main orders, if the seller has chosen ship-with-popshop and no matter the main orders have shipping label or not, but before the orders are shipped and completed(note: upper limit of orderIds is 10)
     */
    async orderApiControllerBatchGetShippingLabel(requestParameters: OrderApiControllerBatchGetShippingLabelRequest): Promise<BatchGetShippingLabelResponse> {
        const response = await this.orderApiControllerBatchGetShippingLabelRaw(requestParameters);
        return await response.value();
    }

    /**
     * for new shipping solution, batch preview total shipping cost for many shipping main orders, if the seller has chosen ship-with-popshop and no matter the main orders have shipping label or not, but before the orders are shipped and completed(note: upper limit of orderIds is 10)
     */
    async orderApiControllerBatchPreviewShippingCostRaw(requestParameters: OrderApiControllerBatchPreviewShippingCostRequest): Promise<runtime.ApiResponse<BatchPreviewShippingCostResponse>> {
        if (requestParameters.packageTemplateId === null || requestParameters.packageTemplateId === undefined) {
            throw new runtime.RequiredError('packageTemplateId','Required parameter requestParameters.packageTemplateId was null or undefined when calling orderApiControllerBatchPreviewShippingCost.');
        }

        if (requestParameters.orderIds === null || requestParameters.orderIds === undefined) {
            throw new runtime.RequiredError('orderIds','Required parameter requestParameters.orderIds was null or undefined when calling orderApiControllerBatchPreviewShippingCost.');
        }

        const queryParameters: any = {};

        if (requestParameters.packageTemplateId !== undefined) {
            queryParameters['packageTemplateId'] = requestParameters.packageTemplateId;
        }

        if (requestParameters.orderIds) {
            queryParameters['orderIds'] = requestParameters.orderIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:batchPreviewShippingCost`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for new shipping solution, batch preview total shipping cost for many shipping main orders, if the seller has chosen ship-with-popshop and no matter the main orders have shipping label or not, but before the orders are shipped and completed(note: upper limit of orderIds is 10)
     */
    async orderApiControllerBatchPreviewShippingCost(requestParameters: OrderApiControllerBatchPreviewShippingCostRequest): Promise<BatchPreviewShippingCostResponse> {
        const response = await this.orderApiControllerBatchPreviewShippingCostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerBatchRefundRaw(requestParameters: OrderApiControllerBatchRefundRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.batchRefundOrderRequest === null || requestParameters.batchRefundOrderRequest === undefined) {
            throw new runtime.RequiredError('batchRefundOrderRequest','Required parameter requestParameters.batchRefundOrderRequest was null or undefined when calling orderApiControllerBatchRefund.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:BatchRefund`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchRefundOrderRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerBatchRefund(requestParameters: OrderApiControllerBatchRefundRequest): Promise<void> {
        await this.orderApiControllerBatchRefundRaw(requestParameters);
    }

    /**
     * for new shipping solution, batch update package template for many shipping main orders, if the seller has chosen ship-with-popshop and the orders has no shipping label(note: upper limit of orderIds is 10)
     */
    async orderApiControllerBatchUpdatePackageTemplateRaw(requestParameters: OrderApiControllerBatchUpdatePackageTemplateRequest): Promise<runtime.ApiResponse<BatchUpdatePackageTemplateResponse>> {
        if (requestParameters.batchUpdatePackageTemplateRequest === null || requestParameters.batchUpdatePackageTemplateRequest === undefined) {
            throw new runtime.RequiredError('batchUpdatePackageTemplateRequest','Required parameter requestParameters.batchUpdatePackageTemplateRequest was null or undefined when calling orderApiControllerBatchUpdatePackageTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:batchUpdatePackageTemplate`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchUpdatePackageTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for new shipping solution, batch update package template for many shipping main orders, if the seller has chosen ship-with-popshop and the orders has no shipping label(note: upper limit of orderIds is 10)
     */
    async orderApiControllerBatchUpdatePackageTemplate(requestParameters: OrderApiControllerBatchUpdatePackageTemplateRequest): Promise<BatchUpdatePackageTemplateResponse> {
        const response = await this.orderApiControllerBatchUpdatePackageTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerCancelOrderRaw(requestParameters: OrderApiControllerCancelOrderRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerCancelOrder.');
        }

        if (requestParameters.cancelOrderRequest === null || requestParameters.cancelOrderRequest === undefined) {
            throw new runtime.RequiredError('cancelOrderRequest','Required parameter requestParameters.cancelOrderRequest was null or undefined when calling orderApiControllerCancelOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:cancel`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.cancelOrderRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerCancelOrder(requestParameters: OrderApiControllerCancelOrderRequest): Promise<void> {
        await this.orderApiControllerCancelOrderRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerCaptureRaw(requestParameters: OrderApiControllerCaptureRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.masterOrderId === null || requestParameters.masterOrderId === undefined) {
            throw new runtime.RequiredError('masterOrderId','Required parameter requestParameters.masterOrderId was null or undefined when calling orderApiControllerCapture.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{masterOrderId}:capture`.replace(`{${"masterOrderId"}}`, encodeURIComponent(String(requestParameters.masterOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerCapture(requestParameters: OrderApiControllerCaptureRequest): Promise<void> {
        await this.orderApiControllerCaptureRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerCheckFreeShippingRaw(requestParameters: OrderApiControllerCheckFreeShippingRequest): Promise<runtime.ApiResponse<CheckFreeShippingResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling orderApiControllerCheckFreeShipping.');
        }

        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling orderApiControllerCheckFreeShipping.');
        }

        const queryParameters: any = {};

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:checkFreeShipping`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerCheckFreeShipping(requestParameters: OrderApiControllerCheckFreeShippingRequest): Promise<CheckFreeShippingResponse> {
        const response = await this.orderApiControllerCheckFreeShippingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerChooseServiceLevelRaw(requestParameters: OrderApiControllerChooseServiceLevelRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerChooseServiceLevel.');
        }

        if (requestParameters.chooseServiceLevelRequest === null || requestParameters.chooseServiceLevelRequest === undefined) {
            throw new runtime.RequiredError('chooseServiceLevelRequest','Required parameter requestParameters.chooseServiceLevelRequest was null or undefined when calling orderApiControllerChooseServiceLevel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:chooseServiceLevel`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.chooseServiceLevelRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerChooseServiceLevel(requestParameters: OrderApiControllerChooseServiceLevelRequest): Promise<void> {
        await this.orderApiControllerChooseServiceLevelRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerCreateOrderRaw(requestParameters: OrderApiControllerCreateOrderRequest): Promise<runtime.ApiResponse<CreateOrderResponse>> {
        if (requestParameters.createOrderDto === null || requestParameters.createOrderDto === undefined) {
            throw new runtime.RequiredError('createOrderDto','Required parameter requestParameters.createOrderDto was null or undefined when calling orderApiControllerCreateOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createOrderDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerCreateOrder(requestParameters: OrderApiControllerCreateOrderRequest): Promise<CreateOrderResponse> {
        const response = await this.orderApiControllerCreateOrderRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerCreateOrderInMultiCurrencyRaw(requestParameters: OrderApiControllerCreateOrderInMultiCurrencyRequest): Promise<runtime.ApiResponse<CreateOrderV3Response>> {
        if (requestParameters.createOrderDtoV3 === null || requestParameters.createOrderDtoV3 === undefined) {
            throw new runtime.RequiredError('createOrderDtoV3','Required parameter requestParameters.createOrderDtoV3 was null or undefined when calling orderApiControllerCreateOrderInMultiCurrency.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/orders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createOrderDtoV3,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerCreateOrderInMultiCurrency(requestParameters: OrderApiControllerCreateOrderInMultiCurrencyRequest): Promise<CreateOrderV3Response> {
        const response = await this.orderApiControllerCreateOrderInMultiCurrencyRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerCreateOrderV2Raw(requestParameters: OrderApiControllerCreateOrderV2Request): Promise<runtime.ApiResponse<CreateOrderResponse>> {
        if (requestParameters.createOrderDtoV2 === null || requestParameters.createOrderDtoV2 === undefined) {
            throw new runtime.RequiredError('createOrderDtoV2','Required parameter requestParameters.createOrderDtoV2 was null or undefined when calling orderApiControllerCreateOrderV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/orders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createOrderDtoV2,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerCreateOrderV2(requestParameters: OrderApiControllerCreateOrderV2Request): Promise<CreateOrderResponse> {
        const response = await this.orderApiControllerCreateOrderV2Raw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerCreateShipmentRaw(requestParameters: OrderApiControllerCreateShipmentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerCreateShipment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:create-shipment`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createShipmentRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerCreateShipment(requestParameters: OrderApiControllerCreateShipmentRequest): Promise<void> {
        await this.orderApiControllerCreateShipmentRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerDownloadIcsRaw(requestParameters: OrderApiControllerDownloadIcsRequest): Promise<runtime.ApiResponse<GetIcsResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerDownloadIcs.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:getIcs`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerDownloadIcs(requestParameters: OrderApiControllerDownloadIcsRequest): Promise<GetIcsResponse> {
        const response = await this.orderApiControllerDownloadIcsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerDownloadOrderDigitalAssetRaw(requestParameters: OrderApiControllerDownloadOrderDigitalAssetRequest): Promise<runtime.ApiResponse<GetOrderDigitalProductResponse>> {
        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
            throw new runtime.RequiredError('assetId','Required parameter requestParameters.assetId was null or undefined when calling orderApiControllerDownloadOrderDigitalAsset.');
        }

        if (requestParameters.signature === null || requestParameters.signature === undefined) {
            throw new runtime.RequiredError('signature','Required parameter requestParameters.signature was null or undefined when calling orderApiControllerDownloadOrderDigitalAsset.');
        }

        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version','Required parameter requestParameters.version was null or undefined when calling orderApiControllerDownloadOrderDigitalAsset.');
        }

        const queryParameters: any = {};

        if (requestParameters.signature !== undefined) {
            queryParameters['signature'] = requestParameters.signature;
        }

        if (requestParameters.version !== undefined) {
            queryParameters['version'] = requestParameters.version;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/purchased-digital-assets/{assetId}:download`.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters.assetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerDownloadOrderDigitalAsset(requestParameters: OrderApiControllerDownloadOrderDigitalAssetRequest): Promise<GetOrderDigitalProductResponse> {
        const response = await this.orderApiControllerDownloadOrderDigitalAssetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerExportLiveStreamOrdersAsCSVRaw(requestParameters: OrderApiControllerExportLiveStreamOrdersAsCSVRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling orderApiControllerExportLiveStreamOrdersAsCSV.');
        }

        const queryParameters: any = {};

        if (requestParameters.target !== undefined) {
            queryParameters['target'] = requestParameters.target;
        }

        if (requestParameters.shippingMethod) {
            queryParameters['shippingMethod'] = requestParameters.shippingMethod;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/orders:export-csv`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async orderApiControllerExportLiveStreamOrdersAsCSV(requestParameters: OrderApiControllerExportLiveStreamOrdersAsCSVRequest): Promise<string> {
        const response = await this.orderApiControllerExportLiveStreamOrdersAsCSVRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerExportSellerUnshippedOrdersAsCSVRaw(requestParameters: OrderApiControllerExportSellerUnshippedOrdersAsCSVRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling orderApiControllerExportSellerUnshippedOrdersAsCSV.');
        }

        const queryParameters: any = {};

        if (requestParameters.createdBefore !== undefined) {
            queryParameters['createdBefore'] = requestParameters.createdBefore;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/unshipped-orders:export-csv`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async orderApiControllerExportSellerUnshippedOrdersAsCSV(requestParameters: OrderApiControllerExportSellerUnshippedOrdersAsCSVRequest): Promise<string> {
        const response = await this.orderApiControllerExportSellerUnshippedOrdersAsCSVRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerFinalizeOrderRaw(requestParameters: OrderApiControllerFinalizeOrderRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerFinalizeOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:finalize`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerFinalizeOrder(requestParameters: OrderApiControllerFinalizeOrderRequest): Promise<void> {
        await this.orderApiControllerFinalizeOrderRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerGenerateLabelRaw(requestParameters: OrderApiControllerGenerateLabelRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerGenerateLabel.');
        }

        if (requestParameters.generateLabelRequest === null || requestParameters.generateLabelRequest === undefined) {
            throw new runtime.RequiredError('generateLabelRequest','Required parameter requestParameters.generateLabelRequest was null or undefined when calling orderApiControllerGenerateLabel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:generateLabel`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.generateLabelRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerGenerateLabel(requestParameters: OrderApiControllerGenerateLabelRequest): Promise<void> {
        await this.orderApiControllerGenerateLabelRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerGetOrderDigitalAssetRaw(requestParameters: OrderApiControllerGetOrderDigitalAssetRequest): Promise<runtime.ApiResponse<GetOrderDigitalProductResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerGetOrderDigitalAsset.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:getDigitalAsset`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerGetOrderDigitalAsset(requestParameters: OrderApiControllerGetOrderDigitalAssetRequest): Promise<GetOrderDigitalProductResponse> {
        const response = await this.orderApiControllerGetOrderDigitalAssetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async orderApiControllerGetOrderStatsRaw(requestParameters: OrderApiControllerGetOrderStatsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerGetOrderStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:stats`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Public API
     */
    async orderApiControllerGetOrderStats(requestParameters: OrderApiControllerGetOrderStatsRequest): Promise<void> {
        await this.orderApiControllerGetOrderStatsRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerGetShipmentTransactionsRaw(requestParameters: OrderApiControllerGetShipmentTransactionsRequest): Promise<runtime.ApiResponse<ShipmentTransactionResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerGetShipmentTransactions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:getShipmentTransactions`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerGetShipmentTransactions(requestParameters: OrderApiControllerGetShipmentTransactionsRequest): Promise<ShipmentTransactionResponse> {
        const response = await this.orderApiControllerGetShipmentTransactionsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerGetShippingFeeRaw(requestParameters: OrderApiControllerGetShippingFeeRequest): Promise<runtime.ApiResponse<ShippingFeeResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling orderApiControllerGetShippingFee.');
        }

        const queryParameters: any = {};

        if (requestParameters.liveStreamId !== undefined) {
            queryParameters['liveStreamId'] = requestParameters.liveStreamId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shipping-fee`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerGetShippingFee(requestParameters: OrderApiControllerGetShippingFeeRequest): Promise<ShippingFeeResponse> {
        const response = await this.orderApiControllerGetShippingFeeRaw(requestParameters);
        return await response.value();
    }

    /**
     * for new shipping solution, get shipping label for a shipping main order, if the seller has chosen ship-with-popshop and no matter the main order has shipping label or not, but before the order is shipped and completed
     */
    async orderApiControllerGetShippingLabelRaw(requestParameters: OrderApiControllerGetShippingLabelRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerGetShippingLabel.');
        }

        if (requestParameters.getShippingCostRequest === null || requestParameters.getShippingCostRequest === undefined) {
            throw new runtime.RequiredError('getShippingCostRequest','Required parameter requestParameters.getShippingCostRequest was null or undefined when calling orderApiControllerGetShippingLabel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:getShippingLabel`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.getShippingCostRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * for new shipping solution, get shipping label for a shipping main order, if the seller has chosen ship-with-popshop and no matter the main order has shipping label or not, but before the order is shipped and completed
     */
    async orderApiControllerGetShippingLabel(requestParameters: OrderApiControllerGetShippingLabelRequest): Promise<void> {
        await this.orderApiControllerGetShippingLabelRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerGetTrackingRecordsRaw(requestParameters: OrderApiControllerGetTrackingRecordsRequest): Promise<runtime.ApiResponse<ShipmentTrackingRecordResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerGetTrackingRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:getTrackingRecords`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerGetTrackingRecords(requestParameters: OrderApiControllerGetTrackingRecordsRequest): Promise<ShipmentTrackingRecordResponse> {
        const response = await this.orderApiControllerGetTrackingRecordsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerGetTrackingRecordsBackwardCompatibleRaw(requestParameters: OrderApiControllerGetTrackingRecordsBackwardCompatibleRequest): Promise<runtime.ApiResponse<ShipmentTrackingRecordBackwardCompatibleResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerGetTrackingRecordsBackwardCompatible.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:getTrackingRecordsBackwardCompatible`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerGetTrackingRecordsBackwardCompatible(requestParameters: OrderApiControllerGetTrackingRecordsBackwardCompatibleRequest): Promise<ShipmentTrackingRecordBackwardCompatibleResponse> {
        const response = await this.orderApiControllerGetTrackingRecordsBackwardCompatibleRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerNotifyRaw(requestParameters: OrderApiControllerNotifyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.masterOrderId === null || requestParameters.masterOrderId === undefined) {
            throw new runtime.RequiredError('masterOrderId','Required parameter requestParameters.masterOrderId was null or undefined when calling orderApiControllerNotify.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{masterOrderId}:packed-notify`.replace(`{${"masterOrderId"}}`, encodeURIComponent(String(requestParameters.masterOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.pickupNotifyDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerNotify(requestParameters: OrderApiControllerNotifyRequest): Promise<void> {
        await this.orderApiControllerNotifyRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerOrderRefundsDetailRaw(requestParameters: OrderApiControllerOrderRefundsDetailRequest): Promise<runtime.ApiResponse<OrderRefundsDetailResponse>> {
        if (requestParameters.orderIds === null || requestParameters.orderIds === undefined) {
            throw new runtime.RequiredError('orderIds','Required parameter requestParameters.orderIds was null or undefined when calling orderApiControllerOrderRefundsDetail.');
        }

        const queryParameters: any = {};

        if (requestParameters.orderIds) {
            queryParameters['orderIds'] = requestParameters.orderIds;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.sortOrder !== undefined) {
            queryParameters['sortOrder'] = requestParameters.sortOrder;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/refunds:detail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerOrderRefundsDetail(requestParameters: OrderApiControllerOrderRefundsDetailRequest): Promise<OrderRefundsDetailResponse> {
        const response = await this.orderApiControllerOrderRefundsDetailRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerOrdersDetailWithRefundRaw(requestParameters: OrderApiControllerOrdersDetailWithRefundRequest): Promise<runtime.ApiResponse<OrdersDetailWithRefundResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerOrdersDetailWithRefund.');
        }

        const queryParameters: any = {};

        if (requestParameters.includeOrdersInSameOrderGroup !== undefined) {
            queryParameters['includeOrdersInSameOrderGroup'] = requestParameters.includeOrdersInSameOrderGroup;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:detail`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerOrdersDetailWithRefund(requestParameters: OrderApiControllerOrdersDetailWithRefundRequest): Promise<OrdersDetailWithRefundResponse> {
        const response = await this.orderApiControllerOrdersDetailWithRefundRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerPreviewBatchRefundRaw(requestParameters: OrderApiControllerPreviewBatchRefundRequest): Promise<runtime.ApiResponse<OrderRefundPreviewResponse>> {
        if (requestParameters.previewBatchRefundOrderRequest === null || requestParameters.previewBatchRefundOrderRequest === undefined) {
            throw new runtime.RequiredError('previewBatchRefundOrderRequest','Required parameter requestParameters.previewBatchRefundOrderRequest was null or undefined when calling orderApiControllerPreviewBatchRefund.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:previewBatchRefund`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.previewBatchRefundOrderRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerPreviewBatchRefund(requestParameters: OrderApiControllerPreviewBatchRefundRequest): Promise<OrderRefundPreviewResponse> {
        const response = await this.orderApiControllerPreviewBatchRefundRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerPreviewOrderRaw(requestParameters: OrderApiControllerPreviewOrderRequest): Promise<runtime.ApiResponse<PreviewOrderResponse>> {
        if (requestParameters.previewOrderDto === null || requestParameters.previewOrderDto === undefined) {
            throw new runtime.RequiredError('previewOrderDto','Required parameter requestParameters.previewOrderDto was null or undefined when calling orderApiControllerPreviewOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.userAgent !== undefined && requestParameters.userAgent !== null) {
            headerParameters['user-agent'] = String(requestParameters.userAgent);
        }

        if (requestParameters.xPopPlatform !== undefined && requestParameters.xPopPlatform !== null) {
            headerParameters['x-pop-platform'] = String(requestParameters.xPopPlatform);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.previewOrderDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerPreviewOrder(requestParameters: OrderApiControllerPreviewOrderRequest): Promise<PreviewOrderResponse> {
        const response = await this.orderApiControllerPreviewOrderRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerPreviewRefundRaw(requestParameters: OrderApiControllerPreviewRefundRequest): Promise<runtime.ApiResponse<OrderRefundPreviewResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerPreviewRefund.');
        }

        if (requestParameters.previewRefundOrderRequest === null || requestParameters.previewRefundOrderRequest === undefined) {
            throw new runtime.RequiredError('previewRefundOrderRequest','Required parameter requestParameters.previewRefundOrderRequest was null or undefined when calling orderApiControllerPreviewRefund.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:previewRefund`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.previewRefundOrderRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerPreviewRefund(requestParameters: OrderApiControllerPreviewRefundRequest): Promise<OrderRefundPreviewResponse> {
        const response = await this.orderApiControllerPreviewRefundRaw(requestParameters);
        return await response.value();
    }

    /**
     * for new shipping solution, preview total shipping cost for a shipping main order, if the seller has chosen ship-with-popshop and no matter the main order has shipping label or not, but before the order is shipped and completed
     */
    async orderApiControllerPreviewShippingCostRaw(requestParameters: OrderApiControllerPreviewShippingCostRequest): Promise<runtime.ApiResponse<PreviewShippingCostResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerPreviewShippingCost.');
        }

        if (requestParameters.packageTemplateId === null || requestParameters.packageTemplateId === undefined) {
            throw new runtime.RequiredError('packageTemplateId','Required parameter requestParameters.packageTemplateId was null or undefined when calling orderApiControllerPreviewShippingCost.');
        }

        const queryParameters: any = {};

        if (requestParameters.packageTemplateId !== undefined) {
            queryParameters['packageTemplateId'] = requestParameters.packageTemplateId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:previewShippingCost`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for new shipping solution, preview total shipping cost for a shipping main order, if the seller has chosen ship-with-popshop and no matter the main order has shipping label or not, but before the order is shipped and completed
     */
    async orderApiControllerPreviewShippingCost(requestParameters: OrderApiControllerPreviewShippingCostRequest): Promise<PreviewShippingCostResponse> {
        const response = await this.orderApiControllerPreviewShippingCostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerQueryShipmentRaw(requestParameters: OrderApiControllerQueryShipmentRequest): Promise<runtime.ApiResponse<ShippingCostItem>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerQueryShipment.');
        }

        if (requestParameters.queryShipmentRequest === null || requestParameters.queryShipmentRequest === undefined) {
            throw new runtime.RequiredError('queryShipmentRequest','Required parameter requestParameters.queryShipmentRequest was null or undefined when calling orderApiControllerQueryShipment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:queryShipment`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.queryShipmentRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerQueryShipment(requestParameters: OrderApiControllerQueryShipmentRequest): Promise<ShippingCostItem> {
        const response = await this.orderApiControllerQueryShipmentRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerReCreatShipmentRaw(requestParameters: OrderApiControllerReCreatShipmentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerReCreatShipment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:recreate-shipment`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerReCreatShipment(requestParameters: OrderApiControllerReCreatShipmentRequest): Promise<void> {
        await this.orderApiControllerReCreatShipmentRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerRefundRaw(requestParameters: OrderApiControllerRefundRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerRefund.');
        }

        if (requestParameters.refundOrderRequest === null || requestParameters.refundOrderRequest === undefined) {
            throw new runtime.RequiredError('refundOrderRequest','Required parameter requestParameters.refundOrderRequest was null or undefined when calling orderApiControllerRefund.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:refund`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.refundOrderRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerRefund(requestParameters: OrderApiControllerRefundRequest): Promise<void> {
        await this.orderApiControllerRefundRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerRegenerateLabelsRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:regenerate-labels`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerRegenerateLabels(): Promise<void> {
        await this.orderApiControllerRegenerateLabelsRaw();
    }

    /**
     */
    async orderApiControllerRegenerateLabelsStatusRaw(): Promise<runtime.ApiResponse<LabelRegenerationJobStatus>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders:regenerate-labels-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerRegenerateLabelsStatus(): Promise<LabelRegenerationJobStatus> {
        const response = await this.orderApiControllerRegenerateLabelsStatusRaw();
        return await response.value();
    }

    /**
     */
    async orderApiControllerRetryOrderPaymentRaw(requestParameters: OrderApiControllerRetryOrderPaymentRequest): Promise<runtime.ApiResponse<RetryPaymentResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerRetryOrderPayment.');
        }

        if (requestParameters.retryPaymentRequest === null || requestParameters.retryPaymentRequest === undefined) {
            throw new runtime.RequiredError('retryPaymentRequest','Required parameter requestParameters.retryPaymentRequest was null or undefined when calling orderApiControllerRetryOrderPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:retry-payment`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.retryPaymentRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerRetryOrderPayment(requestParameters: OrderApiControllerRetryOrderPaymentRequest): Promise<RetryPaymentResponse> {
        const response = await this.orderApiControllerRetryOrderPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerSelectShipmentRateRaw(requestParameters: OrderApiControllerSelectShipmentRateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerSelectShipmentRate.');
        }

        if (requestParameters.selectShipmentRateRequest === null || requestParameters.selectShipmentRateRequest === undefined) {
            throw new runtime.RequiredError('selectShipmentRateRequest','Required parameter requestParameters.selectShipmentRateRequest was null or undefined when calling orderApiControllerSelectShipmentRate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:selectShipmentRate`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.selectShipmentRateRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerSelectShipmentRate(requestParameters: OrderApiControllerSelectShipmentRateRequest): Promise<void> {
        await this.orderApiControllerSelectShipmentRateRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerSendOrderConfirmationEmailRaw(requestParameters: OrderApiControllerSendOrderConfirmationEmailRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerSendOrderConfirmationEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:send-confirmation-mail`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerSendOrderConfirmationEmail(requestParameters: OrderApiControllerSendOrderConfirmationEmailRequest): Promise<void> {
        await this.orderApiControllerSendOrderConfirmationEmailRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerSendOrderShippedEmailRaw(requestParameters: OrderApiControllerSendOrderShippedEmailRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.masterOrderId === null || requestParameters.masterOrderId === undefined) {
            throw new runtime.RequiredError('masterOrderId','Required parameter requestParameters.masterOrderId was null or undefined when calling orderApiControllerSendOrderShippedEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{masterOrderId}:send-shipped-mail`.replace(`{${"masterOrderId"}}`, encodeURIComponent(String(requestParameters.masterOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerSendOrderShippedEmail(requestParameters: OrderApiControllerSendOrderShippedEmailRequest): Promise<void> {
        await this.orderApiControllerSendOrderShippedEmailRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerUpdateBraintreeTransactionsRaw(requestParameters: OrderApiControllerUpdateBraintreeTransactionsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerUpdateBraintreeTransactions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:updateTransactions`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateBraintreeTransactions(requestParameters: OrderApiControllerUpdateBraintreeTransactionsRequest): Promise<void> {
        await this.orderApiControllerUpdateBraintreeTransactionsRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerUpdateOrderByCommissionFeeRateRaw(requestParameters: OrderApiControllerUpdateOrderByCommissionFeeRateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling orderApiControllerUpdateOrderByCommissionFeeRate.');
        }

        if (requestParameters.updateOrderByCommissionFeeRateRequest === null || requestParameters.updateOrderByCommissionFeeRateRequest === undefined) {
            throw new runtime.RequiredError('updateOrderByCommissionFeeRateRequest','Required parameter requestParameters.updateOrderByCommissionFeeRateRequest was null or undefined when calling orderApiControllerUpdateOrderByCommissionFeeRate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/orders:updateOrderByCommissionFeeRate`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateOrderByCommissionFeeRateRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateOrderByCommissionFeeRate(requestParameters: OrderApiControllerUpdateOrderByCommissionFeeRateRequest): Promise<void> {
        await this.orderApiControllerUpdateOrderByCommissionFeeRateRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerUpdateOrderPackedStatusRaw(requestParameters: OrderApiControllerUpdateOrderPackedStatusRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.masterOrderId === null || requestParameters.masterOrderId === undefined) {
            throw new runtime.RequiredError('masterOrderId','Required parameter requestParameters.masterOrderId was null or undefined when calling orderApiControllerUpdateOrderPackedStatus.');
        }

        if (requestParameters.updateOrderPackedStatusDto === null || requestParameters.updateOrderPackedStatusDto === undefined) {
            throw new runtime.RequiredError('updateOrderPackedStatusDto','Required parameter requestParameters.updateOrderPackedStatusDto was null or undefined when calling orderApiControllerUpdateOrderPackedStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{masterOrderId}:pack`.replace(`{${"masterOrderId"}}`, encodeURIComponent(String(requestParameters.masterOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateOrderPackedStatusDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateOrderPackedStatus(requestParameters: OrderApiControllerUpdateOrderPackedStatusRequest): Promise<void> {
        await this.orderApiControllerUpdateOrderPackedStatusRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerUpdateOrderPickupStatusRaw(requestParameters: OrderApiControllerUpdateOrderPickupStatusRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.masterOrderId === null || requestParameters.masterOrderId === undefined) {
            throw new runtime.RequiredError('masterOrderId','Required parameter requestParameters.masterOrderId was null or undefined when calling orderApiControllerUpdateOrderPickupStatus.');
        }

        if (requestParameters.updateOrderPickupStatusDto === null || requestParameters.updateOrderPickupStatusDto === undefined) {
            throw new runtime.RequiredError('updateOrderPickupStatusDto','Required parameter requestParameters.updateOrderPickupStatusDto was null or undefined when calling orderApiControllerUpdateOrderPickupStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{masterOrderId}:set-pickup-status`.replace(`{${"masterOrderId"}}`, encodeURIComponent(String(requestParameters.masterOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateOrderPickupStatusDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateOrderPickupStatus(requestParameters: OrderApiControllerUpdateOrderPickupStatusRequest): Promise<void> {
        await this.orderApiControllerUpdateOrderPickupStatusRaw(requestParameters);
    }

    /**
     * for new shipping solution, update package template for a shipping main order, if the seller has chosen ship-with-popshop and the order has no shipping label
     */
    async orderApiControllerUpdatePackageTemplateRaw(requestParameters: OrderApiControllerUpdatePackageTemplateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerUpdatePackageTemplate.');
        }

        if (requestParameters.updatePackageTemplateRequest === null || requestParameters.updatePackageTemplateRequest === undefined) {
            throw new runtime.RequiredError('updatePackageTemplateRequest','Required parameter requestParameters.updatePackageTemplateRequest was null or undefined when calling orderApiControllerUpdatePackageTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:updatePackageTemplate`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updatePackageTemplateRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * for new shipping solution, update package template for a shipping main order, if the seller has chosen ship-with-popshop and the order has no shipping label
     */
    async orderApiControllerUpdatePackageTemplate(requestParameters: OrderApiControllerUpdatePackageTemplateRequest): Promise<void> {
        await this.orderApiControllerUpdatePackageTemplateRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerUpdateShipmentConfigRaw(requestParameters: OrderApiControllerUpdateShipmentConfigRequest): Promise<runtime.ApiResponse<ShippingCostItem>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerUpdateShipmentConfig.');
        }

        if (requestParameters.updateShipmentConfigRequest === null || requestParameters.updateShipmentConfigRequest === undefined) {
            throw new runtime.RequiredError('updateShipmentConfigRequest','Required parameter requestParameters.updateShipmentConfigRequest was null or undefined when calling orderApiControllerUpdateShipmentConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:updateShipmentConfig`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateShipmentConfigRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateShipmentConfig(requestParameters: OrderApiControllerUpdateShipmentConfigRequest): Promise<ShippingCostItem> {
        const response = await this.orderApiControllerUpdateShipmentConfigRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerUpdateShipmentExtraRaw(requestParameters: OrderApiControllerUpdateShipmentExtraRequest): Promise<runtime.ApiResponse<UpdateShipmentExtraResponse>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerUpdateShipmentExtra.');
        }

        if (requestParameters.updateShipmentExtraRequest === null || requestParameters.updateShipmentExtraRequest === undefined) {
            throw new runtime.RequiredError('updateShipmentExtraRequest','Required parameter requestParameters.updateShipmentExtraRequest was null or undefined when calling orderApiControllerUpdateShipmentExtra.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:updateShipmentExtra`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateShipmentExtraRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateShipmentExtra(requestParameters: OrderApiControllerUpdateShipmentExtraRequest): Promise<UpdateShipmentExtraResponse> {
        const response = await this.orderApiControllerUpdateShipmentExtraRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async orderApiControllerUpdateShippingAddressRaw(requestParameters: OrderApiControllerUpdateShippingAddressRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerUpdateShippingAddress.');
        }

        if (requestParameters.updateShippingAddressRequest === null || requestParameters.updateShippingAddressRequest === undefined) {
            throw new runtime.RequiredError('updateShippingAddressRequest','Required parameter requestParameters.updateShippingAddressRequest was null or undefined when calling orderApiControllerUpdateShippingAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:updateShippingAddress`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateShippingAddressRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateShippingAddress(requestParameters: OrderApiControllerUpdateShippingAddressRequest): Promise<void> {
        await this.orderApiControllerUpdateShippingAddressRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerUpdateShippingAddressBySellerRaw(requestParameters: OrderApiControllerUpdateShippingAddressBySellerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerUpdateShippingAddressBySeller.');
        }

        if (requestParameters.updateShippingAddressBySellerRequest === null || requestParameters.updateShippingAddressBySellerRequest === undefined) {
            throw new runtime.RequiredError('updateShippingAddressBySellerRequest','Required parameter requestParameters.updateShippingAddressBySellerRequest was null or undefined when calling orderApiControllerUpdateShippingAddressBySeller.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:updateShippingAddressBySeller`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateShippingAddressBySellerRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateShippingAddressBySeller(requestParameters: OrderApiControllerUpdateShippingAddressBySellerRequest): Promise<void> {
        await this.orderApiControllerUpdateShippingAddressBySellerRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerUpdateTrackingInfoRaw(requestParameters: OrderApiControllerUpdateTrackingInfoRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerUpdateTrackingInfo.');
        }

        if (requestParameters.updateOrderTrackingInfoDto === null || requestParameters.updateOrderTrackingInfoDto === undefined) {
            throw new runtime.RequiredError('updateOrderTrackingInfoDto','Required parameter requestParameters.updateOrderTrackingInfoDto was null or undefined when calling orderApiControllerUpdateTrackingInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:track`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateOrderTrackingInfoDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateTrackingInfo(requestParameters: OrderApiControllerUpdateTrackingInfoRequest): Promise<void> {
        await this.orderApiControllerUpdateTrackingInfoRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerUpdateTrackingRecordRaw(requestParameters: OrderApiControllerUpdateTrackingRecordRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerUpdateTrackingRecord.');
        }

        if (requestParameters.recordId === null || requestParameters.recordId === undefined) {
            throw new runtime.RequiredError('recordId','Required parameter requestParameters.recordId was null or undefined when calling orderApiControllerUpdateTrackingRecord.');
        }

        if (requestParameters.patchShipmentTrackingRecordItemRequest === null || requestParameters.patchShipmentTrackingRecordItemRequest === undefined) {
            throw new runtime.RequiredError('patchShipmentTrackingRecordItemRequest','Required parameter requestParameters.patchShipmentTrackingRecordItemRequest was null or undefined when calling orderApiControllerUpdateTrackingRecord.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}/tracking-record/{recordId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))).replace(`{${"recordId"}}`, encodeURIComponent(String(requestParameters.recordId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchShipmentTrackingRecordItemRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerUpdateTrackingRecord(requestParameters: OrderApiControllerUpdateTrackingRecordRequest): Promise<void> {
        await this.orderApiControllerUpdateTrackingRecordRaw(requestParameters);
    }

    /**
     */
    async orderApiControllerVoidShipmentRaw(requestParameters: OrderApiControllerVoidShipmentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerVoidShipment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:voidShipment`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerVoidShipment(requestParameters: OrderApiControllerVoidShipmentRequest): Promise<void> {
        await this.orderApiControllerVoidShipmentRaw(requestParameters);
    }

    /**
     * for new shipping solution, void shipping label by tracking record ID for a shipping main order, if the seller has chosen ship-with-popshop and before the order is shipped and completed
     */
    async orderApiControllerVoidShippingLabelRaw(requestParameters: OrderApiControllerVoidShippingLabelRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling orderApiControllerVoidShippingLabel.');
        }

        if (requestParameters.voidShippingLabelRequest === null || requestParameters.voidShippingLabelRequest === undefined) {
            throw new runtime.RequiredError('voidShippingLabelRequest','Required parameter requestParameters.voidShippingLabelRequest was null or undefined when calling orderApiControllerVoidShippingLabel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/orders/{orderId}:voidShippingLabel`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.voidShippingLabelRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * for new shipping solution, void shipping label by tracking record ID for a shipping main order, if the seller has chosen ship-with-popshop and before the order is shipped and completed
     */
    async orderApiControllerVoidShippingLabel(requestParameters: OrderApiControllerVoidShippingLabelRequest): Promise<void> {
        await this.orderApiControllerVoidShippingLabelRaw(requestParameters);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum OrderApiControllerExportLiveStreamOrdersAsCSVTargetEnum {
    Admin = 'admin',
    Seller = 'seller'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderApiControllerExportLiveStreamOrdersAsCSVShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderApiControllerOrderRefundsDetailTypeEnum {
    Refund = 'refund',
    Cancel = 'cancel'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderApiControllerOrderRefundsDetailSortOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderApiControllerPreviewOrderXPopPlatformEnum {
    Psl = 'psl',
    Popstore = 'popstore'
}
